import { createContext } from "react";
import type { ReactNode } from "react";

/** A record of the client case file (Kundenakt) that is edited in a dialog of its own. */
export enum ClientFileEntryKind {
  Claim = "claim",
  ClientSpecificCreditor = "clientSpecificCreditor",
}

/** The one record a dialog has open, for the info line that reports on it. */
export interface ClientFileEntry {
  kind: ClientFileEntryKind;
  id: string;
}

/**
 * App-provided info line of the client case file (Kundenakt): when and by whom the data of the view
 * on screen was created and last changed, rendered by that view next to its own actions. Built on
 * demand rather than handed over as a ready node, because a dialog is the only place that knows
 * which record it has open — called with that record, and with nothing for a page, whose data the
 * app resolves from the route. The internal app provides its change-info line here, clickable into
 * that view's change history; an app that provides nothing renders nothing extra.
 */
export const ClientFileInfoLineContext = createContext<((entry?: ClientFileEntry) => ReactNode) | null>(null);
